import Logger from "logger/logger"
import {useEffect, useState} from "react"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"

function ThemeService(caller: string) {

  const {theme} = EnvironmentService([
    subscribeEnv.theme,
  ], 'ThemeService')

  const [isLoading, setIsLoading] = useState<boolean>()

  useEffect(() => {
    Logger('Service.Theme.init', caller)
    return () => {
      Logger('Service.Theme.unloading', caller)
    }
  }, [])

  useEffect(function loadTheme() {
    (async () => {
      setIsLoading(true)
      await import(`../../../scss/themes/${theme}/index.scss`)
      setIsLoading(false)
    })()
  }, [theme])

  return {
    isLoadingTheme: isLoading
  }
}

export default ThemeService
